import React from 'react';
import { useRecoilState } from 'recoil';
import { Snackbar, Alert, AlertProps } from '@mui/material';

import { SnackbarMessage } from '../../hooks/useSnackbar.types';


import { atom } from 'recoil';

export type AlertColor = 'success' | 'info' | 'warning' | 'error';

export const snackbarState = atom({
  key: 'snackbarState',
  default: { open: false, message: '', severity: '' as AlertColor },
});

const CustomSnackbar: React.FC = () => {
  const [snackbar, setSnackbar] = useRecoilState(snackbarState);

  const isSticky = snackbar.message === SnackbarMessage.CUSTOM_PERMISSIONS_SITE_SETUP_INVALID;

  const handleClose = (_event?: unknown, reason?: string) => {
    if (isSticky && (reason === 'timeout' || reason === 'clickaway')) return;
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={snackbar.open}
      autoHideDuration={isSticky ? null : 3500}
      onClose={handleClose}
    >
      <Alert severity={snackbar.severity} onClose={(e) => handleClose(e, 'manual')} sx={{ width: '100%', whiteSpace: 'pre-line' }}>
        {snackbar.message}
      </Alert>
    </Snackbar>
  );
};

export default CustomSnackbar;
